import {
  CollectionReference,
  DocumentData,
  QueryConstraint,
  collection,
  getDocs,
  limit,
  query
} from "firebase/firestore";
import { db } from "../lib/firebase";
import { AdminServiceResult, TimestampLike } from "./types";

export function emptyResult<T>(data: T, error: unknown): AdminServiceResult<T> {
  logDevelopmentError(error);
  return {
    data,
    error: error instanceof Error ? error.message : "Unable to load admin data."
  };
}

export function successfulResult<T>(data: T): AdminServiceResult<T> {
  return { data, error: null };
}

export function logDevelopmentError(error: unknown) {
  if (import.meta.env.DEV) {
    console.error("[chor-admin] Firestore read failed", error);
  }
}

export function adminCollection(path: string): CollectionReference<DocumentData> {
  return collection(db, path);
}

export async function safeLimitedDocs(collectionName: string, itemLimit = 10, constraints: QueryConstraint[] = []) {
  const snapshot = await getDocs(query(adminCollection(collectionName), ...constraints, limit(itemLimit)));
  return snapshot.docs;
}

export function stringField(data: DocumentData, key: string): string | null {
  const value = data[key];
  return typeof value === "string" && value.trim().length > 0 ? value : null;
}

export function stringArrayField(data: DocumentData, key: string): string[] {
  const value = data[key];
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === "string") : [];
}

export function dateField(data: DocumentData, key: string): Date | null {
  const value = data[key] as TimestampLike | Date | undefined;

  if (value instanceof Date) {
    return value;
  }

  if (value?.toDate) {
    return value.toDate();
  }

  if (typeof value?.seconds === "number") {
    return new Date(value.seconds * 1000);
  }

  return null;
}
